



















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import FormItem from '@/components/money/FormItem.vue';
import Button from '@/components/Button.vue';
import store from '../store/index';

@Component({
    components: {FormItem,Button},
  })
export default class EditLabel extends Vue {
    get tag(){
       return this.$store.state.currentTag;
     }

    created() {
      const id = this.$route.params.id;
      //防止刷新页面直接跳转到404
      //刷新页面后会导致其他组件还没运行就转到当前页了，数据为空
      this.$store.commit('fetchTags');
      this.$store.commit('setCurrentTag',id);
      if(!this.tag){
        this.$router.replace('/404');
      }
     
    }

    update(name: string) {
      if (this.tag) {
        this.$store.commit('updateTag',{id:this.tag.id,name});
      }
     }

    remove(){
      if(this.tag){
        this.$store.commit('removeTag',this.tag.id);
      }
    }

    goBack() {
      this.$router.back();
    }
}
